exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pg-wrapper .control.is-animate .input[data-v-694be4d8]{z-index:8}.pg-wrapper .edit-from .input[data-v-694be4d8]{text-align:left;margin-top:7px}.day-month-year-picker p[data-v-694be4d8]{font-size:12px;padding:8px 8px;padding-bottom:0}.edit-account-dob select[data-v-694be4d8]{height:32px!important;padding-top:0}.control.select.is-full-width.pr-5[data-v-694be4d8]{padding-right:25px;padding-left:14px}.edit-account .is-checkradio[type=checkbox]+label[data-v-694be4d8]:after{top:4px}", ""]);

// exports
